import { Form } from "antd";

import { SeverityFieldNames } from "@/components/FormEngine/Editor/DragAndDropTool/Field/Severity/constants";
import { getSelectedComponent } from "@/components/FormEngine/Editor/DragAndDropTool/Field/Severity/gridUtils";

import { useSeverityGridFromInterventionAsset } from "./useSeverityGridFromInterventionAsset";

const { useFormInstance, useWatch } = Form;

export const useDefectsFromSeverityGrid = () => {
  const form = useFormInstance();
  const selection = useWatch(SeverityFieldNames.component, form);
  const { isLoading, severityGrid, isGridDefinedForAsset } =
    useSeverityGridFromInterventionAsset();
  const component = getSelectedComponent({
    selection,
    severityGrid,
  });
  const gridMaterials = component?.materials ?? [];

  const materialSelection = useWatch(SeverityFieldNames.material, form);
  const gridDefects =
    gridMaterials.find(({ slug }) => slug === materialSelection)?.defects ?? [];

  return {
    isLoadingGrid: isLoading,
    isGridDefinedForAsset: isGridDefinedForAsset && gridDefects.length > 0,
    gridDefects,
  };
};
